// Deprecated. Database access for agents goes through the MCP server. These agent fields stay in place.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useChatStore = create(persist((set) => ({
    open: false,
    sessionId: null,
    draft: '',
    provider: 'gemini',
    model: 'gemini-3.1-flash-lite',
    launcher: null,
    toggle: () => set((state) => ({ open: !state.open })),
    openChat: () => set({ open: true }),
    close: () => set({ open: false }),
    setSessionId: (sessionId) => set({ sessionId }),
    setDraft: (draft) => set({ draft }),
    setProvider: (provider) => set({ provider }),
    setModel: (model) => set({ model }),
    setLauncher: (launcher) => set({ launcher }),
    newChat: () => set({ sessionId: null, draft: '' }),
}), {
    name: 'agent-chat',
    version: 1,
    migrate: (persisted) => ({
        ...persisted,
        provider: 'gemini',
        model: 'gemini-3.1-flash-lite',
    }),
    partialize: (state) => ({
        open: state.open,
        sessionId: state.sessionId,
        draft: state.draft,
        provider: state.provider,
        model: state.model,
        launcher: state.launcher,
    }),
}));

export default useChatStore;
